<template>
  <div class="item">
    <div class="itemImg" v-bind:style="{backgroundImage:'url('+ getPreviewUrl(item.token)+')',}">
      <router-link :to="{path: '/detail', query: { obj: 'listPage',token: item.token }}">
        <!-- <img :src="getPreviewUrl(item.token)" @click="$emit('gtag','春風共想計畫', '大眾溫柔-我要投票', `${item.subjectTitle}`)"> -->
        <img src="@/assets/img/border.png" @click="$emit('gtag','春風共想計畫', '大眾溫柔-我要投票', `${item.subjectTitle}`)">
      </router-link>
    </div>
    <div class="itemTitle">
      <router-link :to="{path: '/detail', query: { obj: 'listPage',token: item.token }}"
        @click="$emit('gtag','春風共想計畫', '大眾溫柔-我要投票', `${item.subjectTitle}`)">{{item.subjectTitle}}</router-link>
    </div>
    <div class="itemTxt">{{item.subjectBrief}}</div>
    <div class="vote">
      <router-link :to="{path: '/detail', query: { obj: 'listPage',token: item.token }}"><img
          src="@/assets/img/vote.png" @click="$emit('gtag','春風共想計畫', '大眾溫柔-我要投票', `${item.subjectTitle}`)">
      </router-link>
    </div>
    <div class="ticket">{{item.vote}}</div>
  </div>
</template>
<script>
  export default {
    name: 'popupBox',

    data() {
      return {
        // backgroundImage:
      }
    },

  }
</script>
<style scoped lang="scss">
  img+.item {
    padding-top: 0;
  }

  .item {
    display: flex;
    flex-wrap: wrap;
    padding: 30px 0 50px 0;

    &>div {
      width: 100%;
    }

    .itemImg {
      margin-bottom: 10px;
      border-radius: 15px;
      overflow: hidden;
      padding-bottom: calc(100% * 0.61);
      height: 0;
      max-height: calc(100% * 0.61);
      position: relative;
      display: flex;
      background-size: cover;
      background-position: center;

      img {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
      }
    }

    .itemTitle {
      color: #2a2a2a;
      font-size: 20px;
      letter-spacing: 1.4px;
      line-height: 1.4;
      margin-bottom: 5px;
    }

    .itemTxt {
      width: 80%;
      color: #787575;
      font-size: 15px;
      font-weight: 200;
      line-height: 1.7;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      margin-bottom: 10px;
    }

    .vote {
      width: 20%;

      button {
        background: none;
        border: none;
      }

    }

    .ticket {
      color: #e08b87;
      margin-bottom: 10px;

      &::before {
        content: '溫柔票數：';
      }
    }

    .imgBox {
      position: relative;

      &::after {
        position: absolute;
        left: 0;
        top: 0;
        content: '';
        display: block;
        background-image: url(@/assets/img/border.png);
        background-repeat: no-repeat;
        background-size: cover;
        width: 100%;
        height: 100%;
      }
    }

  }
</style>

<script>
  export default {
    name: 'thisItem',
    props: ["title", "text", "item", "apiUrl"],
    methods: {
      getPreviewUrl(token) {
        return this.$props.apiUrl +
          `API/GetFile/507901F0790445F0845A9A620BB6347D/token/${token}/file_portfolioPreviewPic?d=a22_clc_andante_cothink_form&&v=1`;
      },
    }
    // props: ["file_portfolioPreviewPic","subjectTitle","subjectBrief","token","vote"]
  }
</script>